import { Routes, Route } from "react-router-dom";
import Info from "./components/info";
import "./App.css";
import Forms from "./components/Forms";
import StartForm from "./components/starterInfoForms";
import context from "./GlobalData/dataProvider";

export default function App() {
  return (
    <context.Provider value={0}>
      <div>
        <h1 style={{ textAlign: "center", color: "#7462E4" }}>
          Transhelp HIV Survey
        </h1>
        <Routes>
          <Route path="/" element={<Info />} />
          <Route path="IntroInfo" element={<StartForm />} />

          <Route path="survey" element={<Forms />} />
        </Routes>
      </div>
    </context.Provider>
  );
}
